import { render } from "./StockItemBatchesModal.vue?vue&type=template&id=01abf0b0&scoped=true"
import script from "./StockItemBatchesModal.vue?vue&type=script&lang=js"
export * from "./StockItemBatchesModal.vue?vue&type=script&lang=js"

import "./StockItemBatchesModal.vue?vue&type=style&index=0&id=01abf0b0&scoped=true&lang=css"

import exportComponent from "/home/runner/work/rust-webserver/rust-webserver/frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-01abf0b0"]])

export default __exports__